<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Messages" subtitle="See the messages being posted by attendees across the scheduler." :readonly="$authorised('con/schedule/access', 'read')">

		<app-content-head-actions-item text="Delete" icon="delete" :danger="true" :disabled="!selected.length" v-on:click="onDeleteClick" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />
		<app-content-filters-date v-model="filter.from" text="From" :max="filter.to" />
		<app-content-filters-date v-model="filter.to" text="To" :min="filter.from" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no messages found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column text="Date" />
				<app-table-column text="Context" />
				<app-table-column text="User" />
				<app-table-column text="Message" />
				<app-table-column />

			</app-table-head>

			<app-table-body>

				<app-table-row align="top" v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-text :text="item.date | localDate('MM/DD/YYYY h:mma')" />
					<app-table-cell-text :text="item.context.name" :subtext="item.contextType" />
					<app-table-cell-text :text="item.badge.name" v-if="item.badge" :subtext="'Badge #' + item.badge.reference" />
					<app-table-cell-text :text="item.author" v-if="!item.badge" subtext="Admin" />
					<app-table-cell-text :text="item.text" />
					<app-table-cell-select :active="isSelected(item.id)" v-on:click="onSelectToggle(item.id)" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			filter: {
				from: 0,
				to: 0
			},
			layout: '160px 160px 160px auto 24px',
			endpoint: 'convention/schedule/messages',
			live: 'convention/schedule/messages'
		}

	}

}

</script>

<style scoped>

</style>